import { createI18n } from "vue-i18n";

import en from './lang/en'
import zh from './lang/zh'
import rw from './lang/rw'
import hw from './lang/hw'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || 'zh',
  messages: {
    en,
    zh,
    rw,
    hw
  },
  globalInjection: true
})

export default i18n;
